import React from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import { shippingStatuses } from "../../../constants/shipping";

type Tone = "green" | "amber" | "blue" | "red" | "gray";

const toneStyles: Record<Tone, { color: string; bgcolor: string }> = {
  green: { color: "#1B5E20", bgcolor: "#E8F5E9" },
  amber: { color: "#E65100", bgcolor: "#FFF3E0" },
  blue: { color: "#1565C0", bgcolor: "#E3F2FD" },
  red: { color: "#B71C1C", bgcolor: "#FFEBEE" },
  gray: { color: "#455A64", bgcolor: "#ECEFF1" },
};

export const resolveOrderStatus = (order: {
  status?: number;
  shippingStatus?: number;
  paymentStatus?: number;
}): { label: string; tone: Tone } => {
  if (order.status === 0) {
    return { label: "Canceled", tone: "red" };
  }
  if (order.status === 2) {
    return { label: "Out of stock", tone: "gray" };
  }

  const shipping = shippingStatuses[order.shippingStatus ?? 0];
  if (!shipping) {
    return { label: "Pending", tone: "amber" };
  }

  if (order.shippingStatus === 2) {
    return { label: "Shipped", tone: "blue" };
  }
  if (order.shippingStatus != null && order.shippingStatus >= 4) {
    return { label: order.paymentStatus === 1 ? "Completed" : shipping.label, tone: "green" };
  }
  if (order.shippingStatus === 3) {
    return { label: "Failed", tone: "red" };
  }
  return { label: shipping.label.includes("Pending") ? "Pending" : shipping.label, tone: "amber" };
};

interface StatusBadgeProps {
  order: {
    status?: number;
    shippingStatus?: number;
    paymentStatus?: number;
  };
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ order }) => {
  const { label, tone } = resolveOrderStatus(order);
  const styles = toneStyles[tone];

  return (
    <Chip
      size="small"
      label={label}
      sx={{
        height: 24,
        fontSize: 12,
        fontWeight: 600,
        color: styles.color,
        bgcolor: styles.bgcolor,
        borderRadius: "8px",
        maxWidth: 160,
        "& .MuiChip-label": {
          px: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      }}
    />
  );
};

export default StatusBadge;
